<template>
  <div>
    <el-container style="flex-direction: column;">
      <div class="charts-box">
        <div class="tab-boxs">
          <ul class="cityUl">
            <li v-for="(item, index) in areaList" :key="index" @click="tabCityOn(index, item)"
              :class="active == index ? 'active' : ''">{{ item.label }}</li>
          </ul>
          <p class="totalTip">截止到{{nowTime}}，农机三合一平台监测在{{areaName}}作业的小麦收获机械共<span>{{totalInfo.njNum}}</span>台，累计收获面积<span>{{totalInfo.totalArea}}</span>{{totalInfo.areaUnit}}</p>
         <!-- <p class="totalTip">(统计口径为从统计开始时间到截止时间内，曾经在各地区作业过的所有收获机械，包括跨区作业收割机，在此期间的收获作业面积)</p> -->
          <div class="select-block" :style="sliderStyle">
            <div id="ToolChart" :style="sliderStyle"></div>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import "echarts/map/js/china.js"
import Api from "../../Serves/net-api.js";
import Http from "../../Serves/net-http.js";
// import MachMonitor from "./MachMonitor.vue";
import NJNav from '../Index/view/NJNav'
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "ToolStatistics",
  components: {
    NJNav
    // MachMonitor
  },
  data() {
    return {
      active: 0,
      Citychars: "",
      progressTitleClass: '',
      numsClass: '',
      itemList: [],
      njNumList1: [],
      njNumList2: [],
      activeNames: '全部智联机具',
      cityName: this.$store.state.info.govLevel === 1 ? '本市' : '',
      tabDataList: [],
      unit: '',
      sliderStyle: {
        width: '100%'
      },
      areaList: [],
      cityVal:'',
      countyVal:'',
      totalInfo:{},
      nowTime:this.getNowDate(),
      areaName:''
    }
  },

  mounted() {
    this.listForDay()
    this.init()
    let info = JSON.parse(localStorage.getItem('vuex')).info
    this.info = info
    this.areaName=info.areaName
    this.pId = info.provCode
    this.cId = info.cityCode
    this.govLevel=info.govLevel;
    if (info.govLevel == 1) {
      if(this.pId == 11){
        this.getMunicipalityCityList()
      }else{
        this.getCityList()
      }
    }
    if (info.govLevel == 2) {
      this.getCountyList()
    }

  },
  updated() {
    // console.log('leftWid', document.getElementById('tab_items').offsetWidth)
    // let leftWid = document.getElementById('tab_items').offsetWidth > 10 ? document.getElementById('tab_items').offsetWidth : 260
    // let wid = document.getElementsByClassName('tab-boxs')[0].offsetWidth - document.getElementById('tab_items').offsetWidth - 20;
    // this.sliderStyle.width = wid + 'px'
    // this.Citychars.resize()
  },
  methods: {
    getNowDate() {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      const NOW_MONTHS_AGO = `${year}年${month}月${day}日`
      return NOW_MONTHS_AGO
    },

    getMunicipalityCityList(){
      Api.doPost(Http.test + '/area/getCountyByProvCode', { provCode: this.pId }, false, (res) => {
        this.areaList = res.result.map((item)=>{
          return {
            label:item.countyName,
            value:item.countyCode,
          }
        })
        this.areaList .unshift({
          label:'全市',
          value:''
        })
        this.cityVal= this.areaList .value
        this.listForDay()
      })
    },
    getCityList() {
      Api.doPost(Http.test + '/area/getCityOfProvice', { pId: this.pId }, false, (res) => {
        this.areaList = res.result
        this.areaList .unshift({
          label:'全省',
          value:''
        })
        this.cityVal= this.areaList .value
        this.listForDay()
      })
    },
    getCountyList() {

      Api.doPost(Http.test + '/area/getCountyOfCityAndProvice', { cId: this.cId }, false, (res) => {
        this.areaList = res.result
        this.areaList .unshift({
          label:'全市',
          value:''
        })
        this.countyVal=this.areaList.value
        this.listForDay()
      })
    },
    tabCityOn(index, item) {
      this.active = index
      if(this.govLevel == 1){
        this.cityVal=item.value
      }
      if(this.govLevel == 2){
        this.countyVal=item.value
      }
      
      this.areaName = index!=0?item.label:this.info.areaName
      
      this.listForDay()
    },

    init() {
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.Citychars.resize()
        })
      }, 30)
    },

    listForDay() {
      var parmse = {
        cityCode:  this.cityVal,
        countyCode: this.countyVal,
      }
      var url = Http.test + '/harvestProgress/listForDay'
      Api.doPost(url, parmse, false, res => {
       this.totalInfo = res.result.total;
        this.totalArea=[];
        this.njNum=[];
        this.xData=[];
        let data = JSON.parse(JSON.stringify(res.result.list));
        data.forEach((item, index) => {
          this.totalArea.push(item.totalArea);
          this.njNum.push(item.njNum);
          this.xData.push(item.workDate.slice(5,13));
        })
        this.$nextTick(() => {
        this.drawChart()
      })

      })

    },

    drawChart() {
        this.Citychars = this.$echarts.init(document.getElementById('ToolChart'))
        this.Citychars.setOption({

          tooltip: {
            trigger: "axis",
            formatter: function (params) {
              var relVal = '<div class="tooltipBox"><span">' + params[0].name + '</span>';
              for (var i = 0, l = params.length; i < l; i++) {
                let unit = params[i].seriesName == '作业面积' ? '亩' : '台'
                relVal += '<br/> <span>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit + '</span>'
              }
              relVal += '</div>'
              return relVal
            }
          },
          legend: {
            data: ['作业农机', '作业面积'],
            top: '0', // 距离容器上边界40像素
            right: '0%',
            textStyle: {
              color: '#ffffff',
              fontSize: 14
            }
          },
          grid: {
            top: '18%', // 距离容器上边界40像素
            bottom: '6%', // 距离容器下边界30像素
            left: 45,
            right: 80,
          },
          dataZoom: [
            //X轴滑动条
            {
              type: 'slider', //滑动条
              //							show: this.tabDataList.length > 15 ? true : false, //开启
              show: true,
              xAxisIndex: [0],
              left: '3%', //滑动条位置
              bottom: '0%',
              height: 10,
              start: 0, //初始化时，滑动条宽度开始标度
              end: this.xData.length > 15 ? 35 : 100 //初始化时，滑动条宽度结束标度
            },
            //X轴内置滑动
            {
              type: 'inside', //内置滑动，随鼠标滚轮展示
              xAxisIndex: [0],
              start: 1, //初始化时，滑动条宽度开始标度
              end: 100 //初始化时，滑动条宽度结束标度
            }
          ],
          xAxis: [{
            type: 'category',
            axisLabel: {
              color: '#C8C7DD',
              fontSize: 16,
              // rotate: 45
              // fontWeight: 'bold'
            },
            axisLine: {
              lineStyle: {
                color: '#dddddd'
              },
              width: 5
            },
            axisTick: {
              show: false
            },
            data: this.xData
          }],
          yAxis: [{
            type: 'value',
            name: '作业农机（台）',
            position: 'left',
            nameTextStyle: {
              color: '#C8C7DD'
            },
            axisLabel: {
              show: true,
              color: '#C8C7DD',
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#dddddd'
              },
              width: 5
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                width: 0.2,
                type: 'dashed',
                color: '#e9e9e9'
              }
            }
          },
          {
            type: 'value',
            name: '作业面积（亩）',
            position: 'right',
            nameTextStyle: {
              color: '#C8C7DD'
            },
            axisLabel: {
              show: true,
              color: '#C8C7DD',
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#dddddd'
              },
              width: 5
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                // type: 'dashed',
                color: 'rgba(150, 164, 244, 0.3)'
              }
            }
          }
          ],
          series: [{
            name: '作业农机',
            type: 'bar',
            barWidth: 24,
            color: "#009CFF",
            // xAxisIndex: 1,
            // yAxisIndex:1,
            // position:'left',
            data: this.njNum
            // data: [2000.56, 33235, 45664, 4584, 8978, 1239, 45646, 4586, 74841]
          },
          {
            name: '作业面积',
            type: 'line',
            yAxisIndex: 1,
            color: '#FFA200',
            data: this.totalArea,
            symbolSize: 10,   //设定实心点的大小
          }
          ]
        })
    },
    timeFormat(date) {
      if (!date || typeof date === 'string') {
        this.error('参数异常，请检查...')
      }
      var y = date.getFullYear() // 年
      // this.yearValue = y
      var m = date.getMonth() + 1 // 月
      var d = date.getDate() // 日
      if (m >= 1 && m <= 9) {
        m = '0' + m
      }
      if (d >= 1 && d <= 9) {
        d = '0' + d
      }
      return y + '-' + m + '-' + d
    },
    // 获取本年第一个月
    getFirstDayOfYear(date) {
      date.setDate(1)
      date.setMonth(0)
      return this.timeFormat(date)
    },
    // 获取当前日期
    getNowFormatDates() {
      var date = new Date()
      // var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      // var currentdate = year + seperator1 + month + seperator1 + strDate
      var currentdate = year + '年' + month + '月' + strDate + '日'
      return currentdate
    }
  }
}
</script>
<style scoped>
.countStyle {
  font-size: 22px;
  font-weight: normal;
}

/*里面的代码可以根据自己需求去进行更改*/
/* 设置滚动条的样式 */

::-webkit-scrollbar {
  width: 3px;
}

/* 滚动槽 */

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

/* 滚动条滑块 */

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #0A63C6;
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}

.toolStatistics {
  width: 100%;
  height: 72vh;
}

.charts-box {
  width: 98%;
  background-image: url('/static/img/zuoyejindu-bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  height: 75vh;
  /* height: 80vh; */
  margin-left: 1%;
  margin-top: 1vh;
}

/* @media screen and (max-width: 1540px) {
		.charts-box {
			height: 89vh;
		}
	}

	.select-block-pro {
		width: 100%;
		height: 70vh;
	} */

.select-block {
  height: 75vh;
  float: left;
}

#ToolChart {
  height: 72vh;
}

.tab-box {
  width: 98%;
  margin-left: 1%;
  /* margin-bottom: 10px; */
  /* margin-top: 20px; */
  /* display: flex; */
}

.tab-boxs {
  width: 99%;
  margin-left: 1%;
  /*display: flex;*/
  /* background: #0B1640; */
  /* justify-content: space-between; */
}

.tablist_box {
  width: 100%;
}

.tablist_item {
  width: 100%;
  display: flex;
  margin-top: -14px;
  /* padding-left: 20px; */
}

.nums {
  width: 75%;
  display: flex;
  margin-top: 10px;
  color: #439BFF;
}

.item-nums {
  width: 15%;
}

/*.item-nums:nth-child(1){
  margin-right: 4vw;
  padding-left: 1vw;
}
.item-nums:nth-child(2){
  margin-right: 5vw;
}
.item-nums:nth-child(3){
  margin-right: 2.5vw;
}*/

.item-nums span:nth-child(2) {
  font-size: 0.8vw;
}

.item-nums span:nth-child(1) {
  font-size: 1.3vw;
}

.item-numss {
  width: 9.7%;
  width: 15%;
}

.item-numss:nth-child(1) {
  margin-right: 4vw;
  padding-left: 1vw;
}

.item-numss:nth-child(2) {
  margin-right: 5vw;
}

.item-numss:nth-child(3) {
  margin-right: 2.5vw;
}

.item-numss span:nth-child(2) {
  font-size: 0.8vw;
}

.item-numss span:nth-child(1) {
  font-size: 1.3vw;
}

.totalInfo{
  font-size: 0.82vw;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: red;
    position: absolute;
    top: 5vh;
    text-align: center;
    width: 100%;
}
.totalTip span{
  font-size: 1vw;
  margin: 0 0.1vw;
  font-weight: bold;
}
.totalTip{
  font-size: 0.92vw;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFF600;
    position: absolute;
    top: 6vh;
    text-align: center;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/WheatHarvest/progress.vue